/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Alert, AlertColor, Snackbar } from "@mui/material";
import { AppContext } from "../../utils/AppContext";
import * as React from "react";
import { useEffect, useState } from "react";
import { INeighborhood, useNeighborhoodService } from "../../services/backend/NeighborhoodService";
import { YesNoCancelPopup } from "../../components/YesNoCancelPopup";
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { NeighborhoodsTable } from "./NeighborhoodsTable";

const Neighborhoods = () => {
  const neighborhoodService = useNeighborhoodService();

  const [alertMessage, setAlertMessage] = useState<string | undefined>(undefined);
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("info");
  const [rows, setRows] = useState<INeighborhood[]>([]);
  const [selectedItem, setSelectedItem] = useState<INeighborhood | undefined>(undefined);
  const [deletePopupVisible, setDeletePopupVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const fetchRows = async () => {
    const neighborhoodList: INeighborhood[] = [];
    let cursor = "0";
    try {
      do {
        const res = await neighborhoodService.listNeighborhoods();
        neighborhoodList.push(...res.list);
        cursor = res.cursor;
      } while (cursor && cursor !== "0");
      setRows(neighborhoodList);
    } catch (e: any) {
      setAlertMessage(e.debugMessage || "Could not fetch the list of neighborhoods.");
      setAlertSeverity("error");
    }
  };

  const refreshButtonClickHandler = async () => {
    setLoading(true);
    await fetchRows();
    setLoading(false);
  };

  const deletePopupNoHandler = () => {
    setDeletePopupVisible(false);
  };

  const deletePopupYesHandler = async () => {
    if (!selectedItem) {
      return;
    }
    try {
      setLoading(true);
      setDeletePopupVisible(false);
      await neighborhoodService.delete(selectedItem.id);
      await fetchRows();
    } catch (e: any) {
      setAlertMessage(e.debugMessage || "Could not delete the selected neighborhood.");
      setAlertSeverity("error");
    } finally {
      setLoading(false);
    }
  };

  const terminateMenuClickHandler = () => {
    setDeletePopupVisible(true);
  };

  const alertCloseHandler = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertMessage(undefined);
  };

  const context = React.useContext(AppContext);
  useEffect(() => {
    if (context) {
      context.setTitle("Neighborhoods");
      context.setTargetAPI("environment");
      if (context.selectedEnvironment) {
        (async () => fetchRows())();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context]);

  return (
    <>
      <NeighborhoodsTable
        rows={rows}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        onRefreshButtonClick={refreshButtonClickHandler}
        onDeleteMenuClick={terminateMenuClickHandler}
      />
      <YesNoCancelPopup
        visible={deletePopupVisible}
        title={"Delete Neighborhood"}
        message={`Are you sure you want to delete the Neighborhood named <b>${selectedItem?.name}</b>?`}
        onNo={deletePopupNoHandler}
        onYes={deletePopupYesHandler}
      />
      <Snackbar open={alertMessage !== undefined} autoHideDuration={5000} onClose={alertCloseHandler}>
        <Alert onClose={alertCloseHandler} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>
      {loading && <LoadingOverlay />}
    </>
  );
};

export default Neighborhoods;
